import { createApi } from "@reduxjs/toolkit/dist/query/react";

import { httpService } from "@services/http.service";

import { IGetCoinsApiResponse } from "./coins.types";

export const coinsApi = createApi({
  reducerPath: "coinsApi",
  baseQuery: httpService({
    baseUrl: `/api/v1`,
  }),
  tagTypes: ["coinsData"],

  endpoints: (build) => ({
    getCoins: build.query<IGetCoinsApiResponse, void>({
      query: () => ({
        url: "/user/info/coins/",
        method: "get",
      }),
    }),
  }),
});

export const { useGetCoinsQuery, useLazyGetCoinsQuery } = coinsApi;
